import React from 'react'
import {
  BrowserRouter as Router,
  Route, Switch
} from 'react-router-dom'
import AboutPage from './AboutPage'
import AccessPage from './AccessPage'
import ContactPage from './ContactPage'
import ContactCompletePage from './ContactCompletePage'
import DetailPage from './DetailPage'
import FaqPage from './FaqPage'
import FlowPage from './FlowPage'
import FooterSection from './FooterSection'
import HeaderSection from './HeaderSection'
import NewsListPage from './NewsListPage'
import PhotosRoomPage from './PhotosRoomPage'
import OpenCampaignPage from './OpenCampaignPage'
import PhotosGardenPage from './PhotosGardenPage'
import PhotosShopPage from './PhotosShopPage'
import PhotosTerrasPage from './PhotosTerrasPage'
import PrivacyPolicyPage from './PrivacyPolicyPage'
import ShopPage from './ShopPage'
import TermsOfUsePage from './TermsOfUsePage'
import TopPage from './TopPage'
import VacancyPage from './VacancyPage'

const App = () => (
  <Router>
    <div className='rooter'>
      <HeaderSection />
      <Switch>
        <Route path='/about' component={AboutPage} />
        <Route path='/access' component={AccessPage} />
        <Route path='/contact' component={ContactPage} />
        <Route path='/contactComplete' component={ContactCompletePage} />
        <Route path='/detail' component={DetailPage} />
        <Route path='/faq' component={FaqPage} />
        <Route path='/flow' component={FlowPage} />
        <Route path='/news' component={NewsListPage} />
        <Route path='/photosRoom' component={PhotosRoomPage} />
        <Route path='/openCampaign' component={OpenCampaignPage} />
        <Route path='/photosGarden' component={PhotosGardenPage} />
        <Route path='/photosShop' component={PhotosShopPage} />
        <Route path='/photosTerras' component={PhotosTerrasPage} />
        <Route path='/privacyPolicy' component={PrivacyPolicyPage} />
        <Route path='/shop' component={ShopPage} />
        <Route path='/termsOfUse' component={TermsOfUsePage} />
        <Route path='/vacancy' component={VacancyPage} />
        <Route component={TopPage} />
      </Switch>
      <FooterSection />
    </div>
  </Router>
)

export default App


// WEBPACK FOOTER //
// ./src/App.js